import React, { Component } from 'react';
import AdminSaleChannelTable from './AdminSaleChannelTable';

export class AdminSaleChannelContent extends Component {
  render() {

    return (
      <AdminSaleChannelTable titleTableList={this.props.titleTableList} />
    )

  }
}

export default AdminSaleChannelContent


// WEBPACK FOOTER //
// ./src/components/Administration/AdminSaleChannels/AdminSaleChannelContent.js